import { select } from '@js/util/select.js'

let loadedCalendly = false
let initializedCalendly = false

// If there is a Consent Manager "calendly" service, wait for that to be approved
let cmService = 'calendly'

if (window.obConsentManagerConfig) {
  ;(async () => {
    await window.obConsentManagerReady
    if (!window.obConsentManager.hasService(cmService)) return
    await window.obConsentManager.awaitConsent(cmService)
    initializeCalendlyIntegration()
  })()
} else {
  initializeCalendlyIntegration()
}

function initializeCalendlyIntegration() {
  select(['a[href^="https://calendly.com/"]'].join(', '), link => {
    if (!loadedCalendly) {
      loadedCalendly = true

      const script = document.createElement('script')
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      document.body.appendChild(script)
      let initializedCalendlyJs = new Promise((resolve, reject) => {
        script.addEventListener('load', resolve)
        script.addEventListener('error', reject)
      })

      const stylesheet = document.createElement('link')
      stylesheet.rel = 'stylesheet'
      stylesheet.href = 'https://assets.calendly.com/assets/external/widget.css'
      document.head.appendChild(stylesheet)
      let initializedCalendlyCss = new Promise((resolve, reject) => {
        stylesheet.addEventListener('load', resolve)
        stylesheet.addEventListener('error', reject)
      })

      Promise.all([initializedCalendlyJs, initializedCalendlyCss]).then(() => {
        initializedCalendly = true
      })
    }

    link.addEventListener('click', event => {
      if (!initializedCalendly) return

      event.preventDefault()
      window.Calendly.initPopupWidget({ url: link.href })
    })
  })
}
